import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
 @font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: local('Lato Medium'), local('Lato-Medium'), url('/Lato/Lato-Medium.woff2') format('woff2');
}
@font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  src: local('Lato Semibold'), local('Lato-Semibold'), url('/Lato/Lato-Semibold.woff2') format('woff2');
}
@font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: local('Lato Bold'), local('Lato-Bold'), url('/Lato/Lato-Bold.woff2') format('woff2');
}
@font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 800;
  font-display: swap;
  src: local('Lato Heavy'), local('Lato-Heavy'), url('/Lato/Lato-Heavy.woff2') format('woff2');
}
@font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: local('Lato Black'), local('Lato-Black'), url('/Lato/Lato-Black.woff2') format('woff2');
}
html,
body,
#root {
  background-color: ${(props) => props.theme.colors.background};
  font-family: ${(props) => props.theme.fonts.default}, sans-serif;
}
`;
